import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";

import Modal from "../../../components/common/Modal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import UpdateAgency from "./UpdateAgency";
import {useToasts} from "react-toast-notifications";
import restService from "../../../services/restService";
import {Badge} from "antd";
import Pusher from "pusher-js";
import Search from "../../../components/common/Search";
import PaginationComponent from "../../../components/common/Pagination";
import AddNewAgency from "../../../components/common/AddNewAgency";
import moment from "moment";
const Agencies = () => {
  const {addToast} = useToasts();
  const [agencyToRemove, setAgencyToRemove] = useState(undefined);
  const [agencyToUpdate, setAgencyToUpdate] = useState(undefined);
  const [agencyToSuspend, setAgencyToSuspend] = useState(undefined);
  const [agencyToActivate, setAgencyToActivate] = useState(undefined);
  const [topUpEValue, setTopUpEValue] = useState(undefined);
  const [topUpEValueAmount, setTopUpEValueAmount] = useState(0);
  const [reduceProfile, setReduceProfile] = useState(undefined);
  const [reduceProfileAmount, setReduceProfileAmount] = useState(0);
  const [callback, setCallback] = useState(() => {});
  const [agencies, setAgencies] = useState([]);
  const [pageTo, setPageTo] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [from, setFrom] = useState(0);
  const [pusherChannel, setPusherChannel] = useState(null);
  const [pusherChannel2, setPusherChannel2] = useState(null);
  const [showAddNewAgency, setShowAddNewAgency] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchAgencies = (page) => {
    setLoading(true);
    restService.AgencyApi.getAgencies(page).then(({data}) => {
      setAgencies(data?.data?.data);
      setPageTo(data?.data?.to);
      setTotalEntries(data?.data?.total);
      setFrom(data?.data?.from);
    }).finally(() => {
      setLoading(false);
    });
  };
  const setTopUpCallback = (data) => {
    let indexOf = -1;
    agencies.forEach((a, index) => {
      if (a.id === data.message?.model.id) {
        indexOf = index;
      }
    });

    if (indexOf >= 0) {
      let agency = agencies[indexOf];
      agency.actual_balance = data.message.model.actual_balance;
      agency.balance_available = data.message.model.balance_available;
      agencies[indexOf] = agency;
      setAgencies([...agencies]);
    }
  };

  const setDebtCallback = (data) => {
    let indexOf = -1;
    agencies.forEach((a, index) => {
      if (a.id === data.message?.model.id) {
        indexOf = index;
      }
    });

    if (indexOf >= 0) {
      let agency = agencies[indexOf];
      agency.balance_owed = data.message.model.balance_owed;
      agencies[indexOf] = agency;

      setAgencies([...agencies]);
    }
  };
  useEffect(() => {
    fetchAgencies();
    const pusher = new Pusher(
        import.meta.env.VITE_API_ENVIRONMENT === "dev"
            ? import.meta.env.VITE_PUSHER_KEY_DEVELOPMENT:
            import.meta.env.VITE_API_ENVIRONMENT === "staging" ?
                import.meta.env.VITE_PUSHER_KEY_STAGING
                : import.meta.env.VITE_PUSHER_KEY_PRODUCTION,
      {
        cluster: "eu",
        forceTLS: true,
      }
    );
    const channel = pusher.subscribe(`general-evalue-topup`);
    setPusherChannel(channel);

    const channel2 = pusher.subscribe(`general-debt-reduction`);
    setPusherChannel2(channel2);
  }, []);

  useEffect(() => {
    if (
      pusherChannel &&
      pusherChannel.bind &&
      pusherChannel2 &&
      pusherChannel2.bind
    ) {
      pusherChannel.unbind("agency-evalue-topup");
      pusherChannel2.unbind("agency-debt-reduction");
      pusherChannel.bind("agency-evalue-topup", setTopUpCallback);
      pusherChannel2.bind("agency-debt-reduction", setDebtCallback);
    }
  }, [pusherChannel, pusherChannel2, agencies]);

  const onAgencyUpdate = () => {
    setAgencyToUpdate(undefined);
    addToast("Successfully Updated Agency", {
      appearance: "success",
      autoDismiss: true,
      autoDismissTimeout: 5000,
    });
    fetchAgencies(currentPage);
  };

  const suspendAgency = () => {
    let data = {id: agencyToSuspend.id, status: "suspended"};
    restService.AgencyApi.updateAgency(data).then((response) => {
      addToast("Successfully Suspended Agency", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      setAgencyToSuspend(undefined);
      fetchAgencies(currentPage);
    });
  };

  const activateAgency = () => {
    let data = {id: agencyToActivate.id, status: "active"};
    restService.AgencyApi.updateAgency(data).then((response) => {
      addToast("Successfully activated Agency", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      setAgencyToActivate(undefined);
      fetchAgencies(currentPage);
    });
  };

  const topUp = () => {
    let data = {amount: topUpEValueAmount};
    restService.EValueAPi.topUpAgency(data, topUpEValue.id)
      .then((response) => {
        addToast("Successfully Topped up Agency e-value", {
          appearance: "success",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      })
      .finally(() => {
        setTopUpEValueAmount(0);
        setTopUpEValue(undefined);
      });
  };

  const reduceDebt = () => {
    let data = {amount: reduceProfileAmount};
    restService.EValueAPi.reduceAgencyDebt(data, reduceProfile.id)
      .then((response) => {
        addToast("Successfully reduced Agency debt profile", {
          appearance: "success",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      })
      .finally(() => {
        setReduceProfileAmount(0);
        setReduceProfile(undefined);
      });
  };

  const removeAgency = () => {
    let data = {id: agencyToRemove.id};
    restService.AgencyApi.removeAgency(data).then((response) => {
      addToast("Successfully Removed Agency", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      setAgencyToRemove(undefined);
      fetchAgencies(currentPage);
    });
  };
  const pageChange = (page) => {
    setCurrentPage(page);
    fetchAgencies(page);
  };
  return (
    <div className="mt-[5rem]">
      <div className="intro-y col-span-12 flex w-full justify-between flex-wrap md:flex-row-reverse sm:flex-nowrap items-center mt-2">
        <button
          onClick={() => setShowAddNewAgency(true)}
          className="btn btn-primary-2 gap-1 items-center shadow-md mr-2"
        >
          <span>
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.98389 1.24805C6.24188 1.24805 6.45103 1.45719 6.45103 1.71519V5.45229H10.1881C10.4461 5.45229 10.6553 5.66144 10.6553 5.91943C10.6553 6.17743 10.4461 6.38657 10.1881 6.38657H6.45103V10.1237C6.45103 10.3817 6.24188 10.5908 5.98389 10.5908C5.72589 10.5908 5.51675 10.3817 5.51675 10.1237V6.38657H1.77964C1.52165 6.38657 1.3125 6.17743 1.3125 5.91943C1.3125 5.66144 1.52165 5.45229 1.77964 5.45229H5.51675V1.71519C5.51675 1.45719 5.72589 1.24805 5.98389 1.24805Z"
                fill="black"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span>Add New Agency</span>
        </button>

        <div className="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div className="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
            <Search
              placeholder={"Search "}
              // onChange={(e) => searchAgentByInput(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
        {loading ? (
          // Loading skeleton
          Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="animate-pulse">
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="p-6 pb-4">
                  <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-gray-200 rounded-full"></div>
                    <div className="flex-1 space-y-2">
                      <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                      <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                      <div className="h-3 bg-gray-200 rounded w-2/3"></div>
                    </div>
                  </div>
                </div>
                <div className="px-6 pb-4">
                  <div className="bg-gray-50 rounded-xl p-4">
                    <div className="h-4 bg-gray-200 rounded w-full"></div>
                  </div>
                </div>
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                  <div className="flex items-center justify-center space-x-3">
                    {Array.from({ length: 4 }).map((_, i) => (
                      <div key={i} className="w-10 h-10 bg-gray-200 rounded-full"></div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : agencies.length === 0 ? (
          // Empty state
          <div className="col-span-full flex flex-col items-center justify-center py-16">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">No agencies found</h3>
            <p className="text-gray-500 text-center max-w-sm">
              Get started by adding your first agency to the system.
            </p>
            <button
              onClick={() => setShowAddNewAgency(true)}
              className="mt-4 btn btn-primary-2 gap-1 items-center shadow-md"
            >
              <span>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M5.98389 1.24805C6.24188 1.24805 6.45103 1.45719 6.45103 1.71519V5.45229H10.1881C10.4461 5.45229 10.6553 5.66144 10.6553 5.91943C10.6553 6.17743 10.4461 6.38657 10.1881 6.38657H6.45103V10.1237C6.45103 10.3817 6.24188 10.5908 5.98389 10.5908C5.72589 10.5908 5.51675 10.3817 5.51675 10.1237V6.38657H1.77964C1.52165 6.38657 1.3125 6.17743 1.3125 5.91943C1.3125 5.66144 1.52165 5.45229 1.77964 5.45229H5.51675V1.71519C5.51675 1.45719 5.72589 1.24805 5.98389 1.24805Z" fill="black" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              <span>Add New Agency</span>
            </button>
          </div>
        ) : (
          agencies.map((agency, index) => {
          return (
            <div key={agency.id || index} className="group relative">
              {/* Modern Card Container */}
              <div className="bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden transform hover:-translate-y-1">
                
                {/* Status Badge */}
                <div className="absolute top-4 right-4 z-10">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    agency.status === 'active' 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-red-100 text-red-700'
                  }`}>
                    {agency.status === 'active' ? 'Active' : 'Inactive'}
                  </span>
                </div>

                {/* Available Balance Badge */}
                <div className="absolute top-4 left-4 z-10">
                  <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-xs font-medium">
                    Available: {agency?.country?.currency_symbol}{agency.balance_available}
                  </span>
                </div>

                {/* Card Header */}
                <div className="p-6 pb-4">
                  <div className="flex items-center space-x-4">
                    <div className="relative">
                      <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-lg">
                        <img
                          alt={agency.name}
                          className="w-14 h-14 rounded-full object-cover border-2 border-white"
                          src="https://www.kindpng.com/picc/m/252-2524695_dummy-profile-image-jpg-hd-png-download.png"
                        />
                      </div>
                      <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full border-2 border-white flex items-center justify-center">
                        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      </div>
                    </div>
                    
                    <div className="flex-1 min-w-0">
                      <h3 className="text-lg font-semibold text-gray-900 truncate">
                        {agency.name}
                      </h3>
                      <p className="text-sm text-gray-500 truncate">
                        {agency.email}
                      </p>
                      <p className="text-sm text-gray-500">
                        {agency.msisdn}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Card Body */}
                <div className="px-6 pb-4">
                  <div className="bg-gray-50 rounded-xl p-4">
                    <div className="flex justify-between items-center">
                      <span className="text-sm font-medium text-gray-600">Actual Balance</span>
                      <span className="text-lg font-bold text-gray-900">
                        {agency?.country?.currency_symbol}{agency.actual_balance}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Card Footer - Actions */}
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                  <div className="flex items-center justify-center space-x-3">
                    <Link
                      to={`/commissions/agency/${agency.id}`}
                      data-tip="View Commissions"
                      className="flex items-center justify-center w-10 h-10 rounded-full bg-green-100 hover:bg-green-200 text-green-600 transition-colors duration-200"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </Link>

                    <Link
                      to={`/statement/agency/${agency.id}`}
                      data-tip="View Statement"
                      className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 hover:bg-blue-200 text-blue-600 transition-colors duration-200"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z" clipRule="evenodd" />
                      </svg>
                    </Link>

                    <button
                      data-tip="Edit Agency"
                      onClick={() => setAgencyToUpdate(agency)}
                      className="flex items-center justify-center w-10 h-10 rounded-full bg-yellow-100 hover:bg-yellow-200 text-yellow-600 transition-colors duration-200"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                      </svg>
                    </button>

                    {agency.status === "active" ? (
                      <button
                        data-tip="Suspend Agency"
                        onClick={() => setAgencyToSuspend(agency)}
                        className="flex items-center justify-center w-10 h-10 rounded-full bg-red-100 hover:bg-red-200 text-red-600 transition-colors duration-200"
                      >
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </button>
                    ) : (
                      <button
                        data-tip="Activate Agency"
                        onClick={() => setAgencyToActivate(agency)}
                        className="flex items-center justify-center w-10 h-10 rounded-full bg-green-100 hover:bg-green-200 text-green-600 transition-colors duration-200"
                      >
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })
        )}
      </div>
      {agencyToRemove && (
        <Modal
          onClick={removeAgency}
          modalTitle="Remove Agency"
          buttonTitle="Remove"
          buttonColor={"bg-red-600"}
          size="small"
          body={
            <p className="text-sm text-gray-500">
              Are you sure you want to remove {agencyToRemove.name}? This action
              cannot be undone.
            </p>
          }
          onClose={() => {
            setAgencyToRemove(undefined);
          }}
        />
      )}
      {agencyToSuspend && (
        <Modal
          onClick={suspendAgency}
          modalTitle="Suspend Agency"
          buttonTitle="Suspend"
          buttonColor={"bg-red-600"}
          size="small"
          body={
            <p className="text-sm text-gray-500">
              Are you sure you want to suspend {`${agencyToSuspend.name} `}?
            </p>
          }
          onClose={() => {
            setAgencyToSuspend(undefined);
          }}
        />
      )}

      {agencyToActivate && (
        <Modal
          onClick={activateAgency}
          modalTitle="Activate Agency"
          buttonTitle="Activate"
          buttonColor={"bg-green-600"}
          size="small"
          body={
            <p className="text-sm text-gray-500">
              Are you sure you want to activate {`${agencyToActivate.name}`}?
            </p>
          }
          onClose={() => {
            setAgencyToActivate(undefined);
          }}
        />
      )}

      {agencyToUpdate && (
        <Modal
          size={"lg"}
          onClick={callback}
          modalTitle="Update agency"
          buttonTitle="Update agency"
          buttonColor="bg-blue-600"
          body={
            <UpdateAgency
              agency={agencyToUpdate}
              initCallback={(callbackFunc) => setCallback(() => callbackFunc)}
              onSubmit={onAgencyUpdate}
            />
          }
          onClose={() => {
            setAgencyToUpdate(undefined);
          }}
        />
      )}

      {topUpEValue && (
        <Modal
          onClick={topUp}
          disableButton={
            !topUpEValueAmount ||
            isNaN(topUpEValueAmount) ||
            topUpEValueAmount <= 0
          }
          modalTitle="Top up agency e-value"
          buttonTitle="Top up"
          buttonColor={"bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800"}
          size="small"
          body={
            <div className="space-y-6">
              {/* Agency Info Card */}
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900">Agency E-Value Top Up</h4>
                    <p className="text-sm text-gray-600">Add funds to the agency's e-value balance</p>
                  </div>
                </div>
              </div>

              {/* Amount Input */}
              <div className="space-y-3">
                <label className="block text-sm font-medium text-gray-700">
                  Top Up Amount <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <input 
                    type="number" 
                    value={topUpEValueAmount}
                    onChange={(e) => setTopUpEValueAmount(e.target.value)}
                    name="topup"
                    className={`w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 ${
                      (!topUpEValueAmount || isNaN(topUpEValueAmount) || topUpEValueAmount <= 0) 
                        ? 'border-red-300 bg-red-50' 
                        : 'border-gray-300'
                    }`}
                    placeholder="Enter amount to add"
                    min="0"
                    step="0.01"
                  />
                </div>
                {(!topUpEValueAmount || isNaN(topUpEValueAmount) || topUpEValueAmount <= 0) && (
                  <p className="text-red-500 text-sm flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    Enter a valid number greater than 0
                  </p>
                )}
              </div>

              {/* Summary Card */}
              {topUpEValueAmount && !isNaN(topUpEValueAmount) && topUpEValueAmount > 0 && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-3">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <h4 className="text-sm font-medium text-blue-900">Transaction Summary</h4>
                  </div>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-blue-700">Amount to add:</span>
                      <span className="font-semibold text-blue-900">${parseFloat(topUpEValueAmount).toFixed(2)}</span>
                    </div>
                    <div className="border-t border-blue-200 pt-2">
                      <div className="flex justify-between">
                        <span className="font-medium text-blue-900">New e-value balance:</span>
                        <span className="font-bold text-blue-900">+${parseFloat(topUpEValueAmount).toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Info Note */}
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
                <div className="flex items-start space-x-2">
                  <svg className="w-4 h-4 text-gray-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <p className="text-xs text-gray-600">
                    The e-value will be added to the agency's account immediately and can be used for operations and agent funding.
                  </p>
                </div>
              </div>
            </div>
          }
          onClose={() => {
            setTopUpEValue(undefined);
            setTopUpEValueAmount(0);
          }}
        />
      )}

      {reduceProfile && (
        <Modal
          onClick={reduceDebt}
          disableButton={
            !reduceProfileAmount ||
            isNaN(reduceProfileAmount) ||
            reduceProfileAmount <= 0
          }
          modalTitle="Reduce agency debt profile"
          buttonTitle="Reduce debt"
          buttonColor={"bg-green-600"}
          size="small"
          body={
            <div className="mt-5">
              <div className="grid grid-cols-12 gap-4 gap-y-5 ">
                <div className="intro-y col-span-12">
                  <label htmlFor="input-wizard-1" className="form-label">
                    Amount *
                  </label>
                  <input
                    id="input-wizard-1"
                    type="number"
                    value={reduceProfileAmount}
                    onChange={(e) => {
                      setReduceProfileAmount(e.target.value);
                    }}
                    name="reduce"
                    className="form-control"
                  />
                  <p className="text-red-500 text-xs italic pt-1">
                    {!reduceProfileAmount ||
                    isNaN(reduceProfileAmount) ||
                    reduceProfileAmount <= 0
                      ? "Enter a valid number greater than 0"
                      : ""}
                  </p>
                </div>
              </div>
            </div>
          }
          onClose={() => {
            setReduceProfile(undefined);
            setReduceProfileAmount(0);
          }}
        />
      )}

      <div className="flex flex-col mb-[10vh] gap-4 justify-between md:items-center md:flex-row mt-8">
        <div className="page text-[#999999] text-xs">
          {agencies && agencies.length <= 0
            ? "No Agencies Found"
            : `Showing ${from} to ${pageTo} of ${totalEntries} entries`}
        </div>

        <div className="mt-3  flex justify-end float-right">
          <PaginationComponent
            current={currentPage}
            defaultCurrent={currentPage}
            showSizeChanger={false}
            onChange={pageChange}
            total={totalEntries}
          />
        </div>
      </div>

      {showAddNewAgency && <AddNewAgency setShow={setShowAddNewAgency} />}
    </div>
  );
};
export default Agencies;
